import { ENDPOINTS } from '@philips-emr/hpms-health-insurance-commons';
import { ThemeTonalRange } from '@philips-emr/tws-constants';
import { HttpService, ModalService } from '@philips-emr/tws-core/lib/services';
import { ResponseBodyMapperType } from '@philips-emr/tws-core/lib/services/http-service';

interface Report {
  cdClassifRelat: string;
  cdRelatorio: string;
  dsTitulo: string;
  nrSequencia: string;
  cdGrupo: string;
  type: string;
  reportPath: string;
}

function changeCursor(isProgress: boolean): void {
  document.body.style.cursor = isProgress ? 'wait' : 'default';
}

function openNewWindow(url: string): void {
  const win = window.open(url, '_blank');
  win && win.focus();
}

function openReportModal(src: string): void {
  ModalService.openFullscreen(
    {
      closeable: true,
      fragment: 'pdf-viewer',
      contextData: { src },
      theme: ThemeTonalRange.ULTRA_LIGHT,
    }
  );
}

function report(userName: string, cdReport: string | number, cdUser: string | number, nrSeqDeclaration: string | number, permissionParams: any): Promise<void> {
  changeCursor(true);

  const responseBodyMapperType: ResponseBodyMapperType = ResponseBodyMapperType.BLOB;

  const parms = {
    user: userName,
    cdReport: cdReport,
    cdUser: cdUser,
    nrSeqDeclaration: nrSeqDeclaration,
  };

  return HttpService.post(ENDPOINTS.POST.REPORT, {}, { responseBodyMapperType, body: { ...parms, permissionParams } })
    .then(response => {
      const { type } = response.body as Report;
      const file = new Blob([response.body as Blob], { type: 'application/pdf' });
      if (type == 'application/json') {
        void file.text().then((result) => {
          openReportModal(result);
        });
      } else {
        const url = URL.createObjectURL(file);
        openNewWindow(url);
      }
    })
    .finally(() => changeCursor(false));
}

export {
  report,
};
